import { HttpStatus } from './http-status.class';

export class HttpRequestStatus extends HttpStatus {
    static readonly READY = 3;

    constructor(code: number = HttpRequestStatus.READY, message: string = "") {
        super(code, message);
    }
}
